import React, { useState } from 'react';
import { Container, Row, Col, Breadcrumb, Button, Dropdown } from 'react-bootstrap';
import { TbHome, TbFileExport, TbCirclePlus } from 'react-icons/tb';
import AddPipelineModal from '../../modals/crm/pipeline/add-pipeline/AddPipelineModal';
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";

const PipelineHeader = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
   
        <Row className="align-items-center justify-content-between">
        
            <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Pipeline</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                 CRM
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Pipeline</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>

          <Col md={6} className="text-md-end">
            <div className="d-flex justify-content-md-end gap-2 flex-wrap ">
              <Dropdown>
                <Dropdown.Toggle variant="white" className="border d-flex align-items-center">
                  <TbFileExport size={18} className="me-2" />
                  Export
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item>Export as PDF</Dropdown.Item>
                  <Dropdown.Item>Export as Excel</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              <Button
                style={{ backgroundColor: '#FF6B00', borderColor: '#FF6B00' }}
                onClick={() => setShowModal(true)}
              >
                <TbCirclePlus size={20} className="me-2" />
                Add Pipeline
              </Button>
            </div>
          </Col>
            {/* Modal - Separate Component */}
      <AddPipelineModal show={showModal} onHide={() => setShowModal(false)} />
        </Row>


    
    </>
  );
};

export default PipelineHeader;